<template>
  <div>
    <section-header ja="プロフィール設定">
      <img src="@/assets/Png/title/settings.png">
    </section-header>
    <setting-list-item>
      <h2>ニックネーム</h2>
      <div class="configured">{{ nickname }}</div>
      <normal-btn @click="onNickname">ニックネームを設定する</normal-btn>
    </setting-list-item>

    <setting-list-item>
      <h2>ユーザーID</h2>
      <div class="configured">{{ playerId }}</div>
    </setting-list-item>

    <setting-list-item>
      <h2>誕生月</h2>
      <div class="configured">{{ birthYearMonth }}</div>
      <normal-btn v-if="birthYearMonth === '未登録'" @click="onBirth">誕生月を設定する</normal-btn>
    </setting-list-item>

    <setting-list-item>
      <h2>会員状態</h2>
      <div class="configured">{{ category }}</div>
      <normal-btn @click="onCategory" v-if="!expire || isFreeMember">
        <template v-if="isFreeMember">有料会員登録する</template>
        <template v-else>変更する</template>
      </normal-btn>
      <div v-else-if="!isApp" class="configured">解約済<br>有料会員期間：{{toDate(expireTime)}}まで</div>
    </setting-list-item>

    <setting-list-item>
      <h2>メールアドレス</h2>
      <div class="configured">
        <template v-if="mailAddress">{{ mailAddress }}</template>
        <template v-else>未登録</template>
      </div>
      <normal-btn @click="onMailAddress">
        <template v-if="mailAddress">メールアドレスを変更する</template>
        <template v-else>メールアドレスを登録する</template>
      </normal-btn>
    </setting-list-item>

    <setting-list-item v-if="mailAddress && securePassword !== '未登録'">
      <h2>パスワード</h2>
      <div class="configured">{{ securePassword }}</div>
      <normal-btn @click="onPassword">パスワードを設定する</normal-btn>
    </setting-list-item>

    <setting-list-item>
      <h2>LINEアカウント</h2>
      <div class="configured">{{ lineUserId }}</div>
      <normal-btn @click="onLINE">LINEアカウントを設定する</normal-btn>
    </setting-list-item>

    <!-- X(旧Twitter)に連携されていれば表示 -->
    <setting-list-item v-if="isLinkedToTwitter">
      <h2>X(旧Twitter)アカウント</h2>
      <div class="configured">{{ twitterUserId }}</div>
      <normal-btn @click="onTwitter">X(旧Twitter)アカウントを設定する</normal-btn>
    </setting-list-item>
  </div>
</template>

<script>
import NormalBtn from '../components/NormalBtn.vue'
import SettingListItem from '../components/SettingListItem.vue'
import SectionHeader from '../components/SectionHeader.vue'
import Line from '../mixins/line'
import Twitter from '../mixins/twitter'
import Screen from '../mixins/screen.js'
import Protobuf from '../mixins/protobuf'
import { splitArray, zeroPadding, ymd } from "../assets/js/util";

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  components: {
    NormalBtn,
    SettingListItem,
    SectionHeader
  },
  mixins: [
    Line,
    Protobuf,
    Screen,
    Twitter
  ],
  data () {
    return {
      nickname: '',
      playerId: 0,
      birthYear: 0,
      birthMonth: 0,
      mailAddress: null,
      membershipGrade: -1,
      paymentType: -1,
      registrationType: -1,
      lineUserId: '未登録',
      twitterUserId: '未登録',
      isLinkedToTwitter: false,
      expireTime: null,
      expire: null,
}
  },
  computed: {
    hasBirthDate() {
      const hasYear = 1990 <= this.birthYear && this.birthYear <= new Date().getFullYear()
      const hasMonth = 1 <= this.birthMonth && this.birthMonth <= 12
      return hasYear && hasMonth
    },
    birthYearMonth() {
      if (this.birthYear >= 1900 && this.birthMonth > 0) {
        return this.birthYear + '年' + this.birthMonth + '月'
      }
      return '未登録'
    },
    category() {
      let s = this.isFreeMember ? '無料会員' : '有料会員'
      if (!this.isFreeMember) {
        s += this.isApp ? '（アプリ内課金）' : '（WEB決済）'
        s += this.toPaymentTypeString(this.paymentType)
      }
      return s
    },
    securePassword() {
      const p = this.$store.getters.securePassword
      return p.length > 0 ? p : '未登録'
    },
    isFreeMember() {
      return this.membershipGrade === pb.PlayerInfoResp.MembershipGrade.GUEST || this.membershipGrade === pb.PlayerInfoResp.MembershipGrade.FREE
    },
    isApp() {
      if(this.isFreeMember) {
        return this.registrationType === pb.PlayerInfoResp.RegistrationType.ANDROID_REGIST || this.registrationType === pb.PlayerInfoResp.RegistrationType.IOS_REGIST
      } else {
        return this.paymentType === pb.PlayerInfoResp.PaymentType.APPLE || this.paymentType === pb.PlayerInfoResp.PaymentType.GOOGLE
      }
    },
    hideCategoryAccessory() {
      return !this.isFreeMember && !this.isCarrier && !this.isCreditCard
    },
    isCarrier() {
      switch (this.paymentType) {
        case pb.PlayerInfoResp.PaymentType.WEB_DOCOMO:
        case pb.PlayerInfoResp.PaymentType.WEB_AU:
        case pb.PlayerInfoResp.PaymentType.WEB_SOFTBANK:
          return true
        default:
          return false
      }
    },
    isCreditCard() {
      return this.paymentType === pb.PlayerInfoResp.PaymentType.WEB_AIME || this.paymentType === pb.PlayerInfoResp.PaymentType.WEB_CARD
    }
  },
  methods: {
    toPaymentTypeString(type) {
      switch (type) {
        case pb.PlayerInfoResp.PaymentType.WEB_DOCOMO:
          return 'd払い'
        case pb.PlayerInfoResp.PaymentType.WEB_AU:
          return 'auかんたん決済(au / UQ mobile)/au PAY'
        case pb.PlayerInfoResp.PaymentType.WEB_SOFTBANK:
          return 'ソフトバンク・ワイモバイルまとめて支払い'
        case pb.PlayerInfoResp.PaymentType.WEB_AIME:
        case pb.PlayerInfoResp.PaymentType.WEB_CARD:
          return 'クレジットカード'
        case pb.PlayerInfoResp.PaymentType.APPLE:
          return 'App Store'
        case pb.PlayerInfoResp.PaymentType.GOOGLE:
          return 'Google Play'
        default:
          return ''
      }
    },
    onNickname() {
      this.$router.push({ name: 'nicknameChange', params: { nickname: this.nickname } })
    },
    onBirth() {
      this.$router.push({ name: 'birthDateChange', params: { month: this.birthMonth, year: this.birthYear } })
    },
    onCategory() {
      if (this.isFreeMember) {
        this.$router.push('/memberBenefits')
      } else if (this.isCarrier) {
        this.$router.push('/paidMemberRemoval2')
      } else if (this.isCreditCard) {
        this.$router.push('/paidMemberChange')
      } else if (this.isApp) {
        this.$router.push('/AboutAppsubscription')
      }
    },
    onPassword() {
      this.$router.push('/passwordChange')
    },
    onMailAddress() {
      this.$router.push('/mailAddressChange')
    },
    onLINE() {
      if (this.lineUserId === '未登録') {
        this.getLineOAuthToken()
      } else {
        this.$router.push('/snsCancel/LINE')
      }
    },
    onTwitter() {
      if (this.twitterUserId === '未登録') {
        this.getTwitterOAuthToken()
      } else {
        this.$router.push('/snsCancel/Twitter')
      }
  },
      toDate(intTime) {
      return ymd(intTime).join('.')
    },
  },
  mounted() {
    const cmdNo = pb.PlayerInfoReq.CommandNo.COMMAND_NO
    const message = pb.PlayerInfoReq.create()
    const encoded = pb.PlayerInfoReq.encode(message).finish()
    this.post(cmdNo, encoded)
      .then(decoded => {
        this.nickname = decoded.nickname !== '' ? decoded.nickname : 'ニックネーム未登録'
        this.playerId =  splitArray(zeroPadding(decoded.playerIdString, 16), 4).join('-')
        this.birthYear = decoded.birthYear
        this.birthMonth = decoded.birthMonth
        this.mailAddress = decoded.mailAddress
        this.registrationType = decoded.registrationType
        this.membershipGrade = decoded.membershipGrade
        this.paymentType = decoded.paymentType
        this.lineUserId = decoded.lineUserId !== '' ? '連携済み' : '未登録'
        this.twitterUserId = decoded.twitterUserId !== '' ? '連携済み' : '未登録'
        this.isLinkedToTwitter = !decoded.twitterUserId ? false : true;

        let expireTime = new Date(decoded.memberExpireDate * 1000);
        let nowTime = new Date(Date.now());
        nowTime.setMonth(nowTime.getMonth() + 13);
        this.expireTime = decoded.memberExpireDate;
        this.expire = (expireTime < nowTime);
      })
      .catch(() => {
        this.$_error('Error', { title: 'プロフィール', statusCode: 100 })
      })

    this.getTwitterAccessToken()
      .then(res=> {
        if (res === undefined) {
          return
        }
        const cmdNo = pb.PlayerUpdateInfoReq.CommandNo.COMMAND_NO
        const message = pb.PlayerUpdateInfoReq.create({
          updateType: pb.PlayerUpdateInfoReq.UpdateType.TWITTER,
          twitterAccessToken: res.token,
          twitterAccessTokenSecret: res.tokenSecret,
          twitterUserId: res.userId
        })
        const encoded = pb.PlayerUpdateInfoReq.encode(message).finish()
        this.post(cmdNo, encoded)
          .then(decoded => {
            if (decoded.status === pb.PlayerUpdateInfoResp.Status.SUCCESS) {
              this.twitterUserId = '連携済み'
              this.$store.dispatch('saveTwitterAccessToken', res.token)
            } else {
              this.$_error('Error', { title: 'プロフィール', statusCode: 400 })
            }
          })
          .catch(() => {
            this.$_error('Error', { title: 'プロフィール', statusCode: 100 })
          })
      })
      .catch(() => {
        this.$_error('Error', { title: 'プロフィール', statusCode: 100 })
      })

    this.getLineAccessToken()
      .then(res => {
        if (res === undefined) {
          return
        }
        const cmdNo = pb.PlayerUpdateInfoReq.CommandNo.COMMAND_NO
        const message = pb.PlayerUpdateInfoReq.create({
          updateType: pb.PlayerUpdateInfoReq.UpdateType.LINE,
          lineAccessToken: res.token,
          lineUserId: res.userId
        })
        const encoded = pb.PlayerUpdateInfoReq.encode(message).finish()
        this.post(cmdNo, encoded)
          .then(decoded => {
            if (decoded.status === pb.PlayerUpdateInfoResp.Status.SUCCESS) {
              this.lineUserId = '連携済み'
              this.$store.dispatch('saveLineAccessToken', res.token)
            } else {
              this.$_error('Error', { title: 'プロフィール', statusCode: 400 })
            }
          })
          .catch(() => {
            this.$_error('Error', { title: 'プロフィール', statusCode: 100 })
          })
      })
      .catch(() => {
        this.$_error('Error', { title: 'プロフィール', statusCode: 100 })
      })
  }
}
</script>

<style lang="scss" scoped>
</style>
